module.exports = __webpack_public_path__ + "static/media/confirmation_sent.9ac86930.jpg";